/* eslint-disable no-undef */
import {getTranslation} from './translations';

const toRaw = typeof Vue !== 'undefined' ? Vue.toRaw : null;

const template = `
	<div class="ubf-dynamicList__item" :class="{ 'js-collapsed' : isCollapsed }">
		<h2 v-if="title" class="ubf-dynamicList__title">
			<template v-if="url">
				<a  class="ubf-dynamicList__titleLink" :href="url" :target="target">{{ title }}</a>
			</template>
			<template v-else>{{ title }}</template>
		</h2>
		<div v-if="showLinks" class="ubf-dynamicList__shareLink">
			<a :href="shareLink" :title="trans('directLink')">
				<span data-type="svg"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false"><use xlink:href="#link"></use></svg></span>
			</a>
		</div>
		<template v-for="definition in definitions">
			<div v-if="!definition.hidden && getData(definition)" class="ubf-dynamicList__values" :class="{'ubf-dynamicList__values--collapsible' : definition.collapsible}">
				<div class="ubf-dynamicList__definition" :class="{ 'js-hidden' : definition.hideLabel}">{{ definition.title }}</div>
				<div class="ubf-dynamicList__value ubf-ugc" v-html="getData(definition)"></div>
			</div>
		</template>
		<button v-if="hasCollapsible" @click="toggleCollapse" class="ubf-dynamicList__toggleButton" type="button" :aria-label="isCollapsed ? trans('open') : trans('close')" :aria-expanded="!isCollapsed">
			<span aria-hidden="true">{{ isCollapsed ? trans('show less') + ' &#9650;' : trans('show more') + ' &#9660;' }}</span>
		</button>
	</div>
`;

function multiSelectOutput(data, selected, definition) {
	if (!data) return '';
	if (!selected) selected = [];
	if (!Array.isArray(data)) data = [];
	return data.map(d => {
		const isSelected = selected.includes(d);
		const preset = definition.preset.find(p => p.id === d);
		const label = preset ? preset.label : '';
		return `<span class="ubf-dynamicList__valueLabel ${isSelected ? 'isSelected' : ''}" class="ubf-dynamicList__valueLabel">${label}</span>`;
	}).join(' ');
}

function singleSelectOutput(data, selected, definition) {
	if (!data) return '';
	if (!selected) selected = '';
	const isSelected = (selected === data);
	const preset = definition.preset.find(p => p.id === data);
	const label = preset ? preset.label : '';
	return `<span class="ubf-dynamicList__valueLabel ${isSelected ? 'isSelected' : ''}">${label}</span>`;
}

function dateOutput(data) {
	if (!data) return '';
	const date = new Date(data);
	if (date.toString() === 'Invalid Date') {
		return '';
	} else {
		return `<span class="ubf-dynamicList__date">${date.toLocaleDateString()}</span>`;
	}
}

function intervalOutput(data) {
	if (!data) return '';
	const start = new Date(data.start);
	const end = new Date(data.end);
	if (start.toString() === 'Invalid Date' && end.toString() === 'Invalid Date') {
		return '';
	} else {
		const startHtml = start.toString() === 'Invalid Date' ? '' : `<span class="ubf-dynamicList__date">${start.toLocaleDateString()} ${start.toLocaleTimeString().substr(0, 5)}</span>`;
		const endHtml = end.toString() === 'Invalid Date' ? '' : `<span class="ubf-dynamicList__date">${end.toLocaleDateString()} ${end.toLocaleTimeString().substr(0, 5)}</span>`;
		return startHtml + endHtml;
	}
}
function linkOutput(data) {
	if (!data) return '';
	const url = data.url;
	let text = data.text;
	if (!text) text = url;
	const target = data.target;
	const style = data.style;
	if (!url) return false;
	return `<a class="ubf-dynamicList__link ${style}" href="${url}" target="${target}">${text}</a>`;
}

export default {
	template: template,
	props: {
		id: String,
		title: String,
		url: String,
		target: String,
		data: Object,
		config: Object,
		definitions: Object,
		filters: Object,
	},
	data: function () {
		return {
			isCollapsed: false
		};
	},
	setup: function (props) {
		let url = props.url;
		if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
			url = 'https://' + url;
		}
		return {
			trans: getTranslation,
			key: props.key,
			shareLink: '#' + props.id,
			data: props.data,
			title: props.title,
			url: url,
			target: props.target,
			config: props.config,
			showLinks: props.config.showLinks,
			definitions: props.definitions,
			filters: props.filters
		};
	},
	computed: {
		hasCollapsible: function () {
			return this.definitions.some(def => def.collapsible === true && def.hidden !== true);
		}
	},
	methods: {
		toggleCollapse: function () {
			this.isCollapsed = !this.isCollapsed;
		},
		getData: function(definition) {
			const id = definition.id;
			const data = this.data[id];
			const type = definition.type;
			const selected = toRaw(this.filters[id]);

			//console.log(id, type, data, selected);
			switch(type) {
				case 'multi-select':
					return multiSelectOutput(data, selected, definition);
				case 'single-select':
					return singleSelectOutput(data, selected, definition);
				case 'date':
					return dateOutput(data);
				case 'interval':
					return intervalOutput(data);
				case 'link':
					return linkOutput(data);
				default:
					return data;
			}
		}
	}
};
